import { IconButton, Tooltip, Dialog, DialogTitle, DialogContent, DialogActions, Button, Box } from '@mui/material';
import { useState } from 'react';
import { useAuth } from 'context/AuthContext';
import { useDeleteProcedure } from 'hooks/useProcedure';
import DeleteIcon from 'icons/DeleteIcon';
import { colors } from 'styles/colors';
import CustomText from 'components/common/CustomText/CustomText';
import CustomDialog from 'components/dialogs/CustomDialog';
import CustomButton from 'components/buttons/CustomButton/CustomButton';
import { snackbarService } from 'services/snackbarService';

interface Props {
  id: number;
  refetch?: () => void;
}

export default function DeletePatientButton({ id, refetch }: Props) {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);

  const { mutate: deleteMutation, isLoading } = useDeleteProcedure(
    (res: any) => {
      const { data, status_code: statusCode } = res;
      if (statusCode == 200) {
        refetch?.();
        setOpen(false);
        snackbarService.showSnackbar('Procedure has been deleted successfully', 'success');
      } else {
        snackbarService.showSnackbar(data, 'error');
      }
    },
    (error: any) => {
      setOpen(false);
    }
  );

  const handleConfirmDelete = () => {
    deleteMutation({
      userId: user.id,
      procedureId: id,
    });
  };

  return (
    <>
      <Tooltip title="Delete">
        <IconButton
          onClick={() => setOpen(true)}
          sx={{
            width: 25,
            height: 25,
            backgroundColor: colors.delete,
            borderRadius: '4px',
            padding: 0,
            '&:hover': {
              backgroundColor: colors.delete,
            },
          }}
        >
          <DeleteIcon size={12} color="white" />
        </IconButton>
      </Tooltip>

      <CustomDialog
        open={open}
        title={'Delete Patient'}
        message={'Note: Deleting this patient is permenant and cannot be undone.'}
        alignText='left'
        buttons={[
          <CustomButton
            variant='outlined'
            text='Cancel'
            textColor='error'
            onClick={() => setOpen(false)}
            disabled={isLoading}
            height={35}
          />,
          <CustomButton
            variant='filled'
            color='error'
            text='Delete'
            onClick={handleConfirmDelete}
            loading={isLoading}
            height={35}
          />,
        ]}
      />
    </>
  );
}
